import Environment from './Environment';
import BaseApi from './BaseApi';

class SelfApi extends BaseApi {
  constructor() {
    super();
    this.url = Environment.alulaApi;
    this.path = 'v1/self';
  }
}

export default new SelfApi();



// WEBPACK FOOTER //
// ./src/api/SelfApi.js